module.exports = __webpack_public_path__ + "static/media/avatar_48.0be2b4dd.svg";